import { Box, Typography, styled } from "@mui/material";
import { useRouter } from "next/router";
import React, { useContext } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { primary } from "../../../constants/theme";
import { Context } from "../../../context/context";
import { sendAnalytics } from "../../../utils/analyticsCommon";

const CustomeBrandLogoTile = styled(Box)(({ theme }) => ({
  margin: "32px 0",
  ".grid-container-style": {
    width: "82%",
    margin: "auto",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    gap: "16px",
  },
  ".grid-item-style": {
    border: `2px solid ${primary.greyText}`,
    padding: "0px 0px",
    minWidth: "150px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    borderRadius: "4px",
    maxWidth: "160px",
  },
  ".grid-item-style.active": {
    border: `2px solid ${primary.main}`,
  },
  ".logo_img": {
    minHeight: "32px",
    objectFit: "contain",
    maxHeight: "50px",
    minWidth: "86px",
    maxWidth: "16px",
    margin: "auto",
    aspectRatio: "3/4",
  },
  ".allvehiclesText": {
    fontWeight: "700",
    color: primary.greyText,
  },
  [theme.breakpoints.down("md")]: {
    ".grid-container-style": {
      width: "100%",
      margin: "auto",
      justifyContent: "center",
      gap: "16px",
    },
    ".grid-item-style": {
      padding: "8px 4px",
      minWidth: "160px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    ".logo_img": {
      minHeight: "32px",
      height: "44.8px",
      maxHeight: "48px",
      minWidth: "70px",
      width: "80px",
      margin: "auto",
    },
  },

  ".content-heading2": {
    fontSize: "24px",
    fontWeight: "600",
    margin: "16px",
    marginLeft: "8%",
  },

  [theme.breakpoints.down("sm")]: {
    ".grid-container-style": {
      width: "100%",
      margin: "auto",
      flexWrap: "wrap",
      justifyContent: "center",
      gap: "16px",
    },
    ".grid-item-style": {
      padding: "0",
      minWidth: "100px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    ".logo_img": {
      minHeight: "24px",
      maxHeight: "45px",
      height: "48px",
      minWidth: "60px",
      maxWidth: "70px",
      width: "80px",
      margin: "auto",
      objectFit: "contain",
    },
    ".allvehiclesText": {
      fontSize: "12px",
    },
    ".content-heading2": {
      fontSize: "24px",
      margin: "16px",
    },
  },
}));

const BrandLogoTile = ({ brand = "", BrandLogos = [], title }) => {
  const navigate = useRouter();
  const state = useContext(Context);
  const { searchQuery } = state;
  return (
    <CustomeBrandLogoTile>
      {title && (
        <Typography className="content-heading2" varient="h2">
          {title}
        </Typography>
      )}

      <Box className="grid-container-style">
        {BrandLogos?.map((item) => {
          return (
            <Box
              item
              xs={2}
              sm={2}
              md={2}
              key={item?.id}
              className={
                brand?.toLowerCase() === item?.BrandName?.toLocaleLowerCase()
                  ? "grid-item-style active"
                  : "grid-item-style"
              }
              onClick={() => {
                const navigationUrl = item?.isPassenger
                  ? `/electric-passenger-vehicles/${item?.BrandName}`
                  : `/electric-commercial-vehicles/${item?.BrandName}`;
                navigate.push(navigationUrl);
                searchQuery("");

                let payload = {
                  brandLogo: item?.BrandName,
                };

                sendAnalytics("sorted_using_brand_logo", payload, "en");
              }}
            >
              {item?.BrandName === "" ? (
                <Typography variant="span" className="allvehiclesText">
                  {item?.vehicle_logo}
                </Typography>
              ) : (
                <LazyLoadImage
                  src={item?.vehicle_logo}
                  visibleByDefault={true}
                  alt={item?.alt}
                  className="logo_img"
                />
              )}
            </Box>
          );
        })}
      </Box>
    </CustomeBrandLogoTile>
  );
};

export default BrandLogoTile;
